import React, {useImperativeHandle, useMemo, useRef, useState} from 'react'
import WizModal from '../../../components/modal/WizModal'
import Text from '../../../components/text/Text'
import WizButton from '../../../components/button/WizButton'
import {INews} from '../../../apis/news/getNewsList'
import WizImage from '../../../components/image/WizImage'
import {useImage} from '../../../utils/image'
import WizSelectButton from '../../../components/button/WizSelectButton'
import {updateNews} from '../../../apis/news/updateNews'

interface IProps {
    className?: string
    refetch?: () => void
}

const UploadNewsModal = ({className, refetch}: IProps, ref: any) => {
    const [news, setNews] = useState<INews>()
    const [view, setView] = useState(false)
    const {renderThumbnail} = useImage()
    const modalRef = useRef<any>()

    useImperativeHandle(ref, () => ({
        show: list => {
            setNews(list)
            setView(list?.is_active)
            modalRef.current.show()
        },
    }))

    const isActiveList = useMemo(
        () => [
            {id: true, value: 'View'},
            {id: false, value: 'Non-View'},
        ],
        [],
    )

    const onClickUploadNews = async () => {
        const {data} = await updateNews(news?.id, view)

        if (data?.success) {
            alert('Changed News Complete!')
            refetch()
            modalRef?.current?.close()
        } else {
            alert('Changed Error')
        }
    }

    return (
        <>
            <WizModal title={'Upload News'} className={`${className}`} ref={modalRef}>
                <Text className={'text-body2 text-font02'}>해당 News를 업로드 하기 전 정보를 확인해주세요.</Text>

                <div className={'mt-[30px] space-y-[30px]'}>
                    <div className={'text-center space-y-[5px]'}>
                        <Text className={'text-font03'}>Title</Text>
                        <Text>{news?.title}</Text>
                    </div>
                    <div className={'text-center space-y-[5px]'}>
                        <Text className={'text-font03'}>Writer</Text>
                        <div className={'flex space-x-[10px] items-center justify-center'}>
                            <WizImage src={renderThumbnail(news?.owner?.thumbnail)} className={'w-[40px]'} />
                            <Text>{news?.owner?.name}</Text>
                        </div>
                    </div>
                    <div className={'text-center space-y-[5px]'}>
                        <Text className={'text-font03'}>Thumbnail</Text>
                        <WizImage src={news?.thumbnail} className={'mx-auto rounded-[10px] w-[200px]'} />
                    </div>
                    <div className={'text-center space-y-[5px]'}>
                        <Text className={'text-font03'}>View</Text>
                        <WizSelectButton
                            data={isActiveList}
                            className={'mx-auto'}
                            onChange={e => {
                                setView(e.id)
                            }}
                            activeValue={isActiveList?.find(item => item.id === view)}
                        />
                    </div>
                </div>
                <div className={'flex space-x-[5px] mt-[30px]'}>
                    <WizButton
                        text={'Cancel'}
                        type={'cancel'}
                        className={'flex-1'}
                        onClick={() => {
                            modalRef.current.close()
                        }}
                    />
                    <WizButton text={'Upload'} type={'blue'} className={'flex-1'} onClick={() => onClickUploadNews()} />
                </div>
            </WizModal>
        </>
    )
}

export default React.forwardRef(UploadNewsModal)
